export const tableHeaders = [
  {
    id: 1,
    label: 'Activity',
    intlKey: 'table.activity'
  },
  {
    id: 3,
    label: 'Date',
    intlKey: 'table.date'
  },
  {
    id: 4,
    label: 'Is Completed',
    intlKey: 'table.is_completed'
  }
]
